import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

const minDate = moment();

const Datefield = ({input, label, htmlFor}) => (
  <div className="form-group">
    <label htmlFor={htmlFor} className="form-group__label">
      {label}
    </label>
    <DatePicker
      onChange={input.onChange}
      selected={input.value ? input.value : null}
      maxDate={minDate}
      peekNextMonth
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      className="datepicker"
    />
  </div>
);

export default Datefield;


// WEBPACK FOOTER //
// ./src/components/application/form/datefield.js